<template>
  <div class="box-style" >

    <van-nav-bar placeholder title="在读" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
        <label @click="getReturnPremium(data)" v-if="data.curriculumId && !data.returnStatus">退费</label>
      </template>
    </van-nav-bar>

    <div class="yj-box">
      <!--        <div class="box-title">-->
      <!--          <h2>课程信息</h2>-->
      <!--          <img src="~@/assets/xl.png">-->
      <!--        </div>-->
      <van-collapse v-model="activeNames">
        <van-collapse-item title="课程信息" name="1">
          <div class="yj-con">
            <!--          <h1>{{ data.curriculumName }}</h1>-->
            <div class="con-list"><span>机构名称：</span>
              <p>{{ data.institutionName }}</p></div>
            <div class="con-list"><span>课程名称：</span>
              <p>{{ data.curriculumName }}</p></div>
            <div class="con-list"><span>上课时间：</span>
              <p>{{ data.classTime }}</p></div>
            <div class="con-list"><span>总课时：</span>
              <p>{{ data.classHour }}</p></div>
            <div class="con-list"><span>报名价格：</span>
              <p>￥{{ data.price }}</p></div>
            <div class="con-list"><span>任课老师：</span>
              <p><em>{{ data.teacherName }}</em></p></div>
            <div class="con-list"><span>上课地点：</span>
              <p>{{ data.address }}</p></div>
            <div class="con-list"><span>开班日期：</span>
              <p>{{ data.startDate }}</p></div>
            <div class="con-list"><span>课程简介：</span>
              <p>{{ data.introduction }}</p></div>
            <div class="con-list"><span>学员姓名：</span>
              <p><em>{{ data.studentName }}</em></p></div>
            <div class="con-list" v-if="data.pic"><span>图片：</span>
              <p><img v-for="(e,i) in data.pic.split(',')" :key="i" :src="fileDisplayPrefix +  e"/></p></div>
            <div class="con-list"><span>剩余课时：</span>
              <p>{{ data.leftHour }}</p></div>
            <div class="con-list"><span>名额：</span>
              <p>{{ data.planCount }}</p></div>
            <div class="con-list"><span>报名人数：</span>
              <p>{{ data.realCount }}</p></div>
          </div>
        </van-collapse-item>
        <van-collapse-item title="消课记录" name="2">
          <div class="yj-con xk-box" v-for="(item,index) in data.curriculumSignDetailVos" :key="index">
            <div class="xk-box-top"><b>消课时间:{{ item.addTime }}</b> <b>消课课时:{{ item.signHour }}</b></div>
            <div class="button-box" v-if="item.status == '0'">
              <van-button @click="confirm(item)" :loading="loading" class="xk-but">确定</van-button>
              <van-button @click="cancel(item)" :loading="loading" class="xk-but org">拒绝</van-button>
              <van-button @click="onDispute()" v-if="item.status != '3'" class="xk-but blue">争议申请</van-button>
            </div>
            <div class="yqr" v-if="item.status == '1'">已确认</div>
            <div class="yjj" v-if="item.status == '2'">已拒绝</div>
            <div class="zyz" v-if="item.status == '3'">争议中</div>
            <div class="dhf" v-if="item.status == '4'">待划付</div>
            <div class="yhf" v-if="item.status == '5'">已划付</div>

          </div>
        </van-collapse-item>
        <van-collapse-item title="退费信息" name="3" v-if="data.returnStatus">
          <div class="yj-con">
            <div class="con-list" v-if="data.returnPic"><span>图片：</span>
              <p><img v-for="(e,i) in data.returnPic.split(',')" :key="i" :src="fileDisplayPrefix +  e"/></p></div>
            <div class="con-list"><span>简介：</span>
              <p>{{ data.returnDes }}</p></div>
            <div class="con-list"><span>退费金额：</span>
              <p class="pre">￥{{ data.returnPrice }}</p></div>
            <div class="con-list">
              <span>审核状态：</span>
              <p>
                <b v-if="data.refundDispute && data.refundDispute.status === '1'">已调处争议</b>
                <b v-else-if="data.returnStatus">{{ this.statusList.filter(res => data.returnStatus === res.value)[0].label }}</b>
              </p>
              <van-button v-if="data.returnStatus ==='1'" round type="info" @click="getDisputeUrl(data.returnId)"><span style="color: white">争议申请</span></van-button>
            </div>
            <div class="con-list" v-if="data.refundDispute && data.refundDispute.status === '1'">
              <span>调处结果：</span>
              <p class="pre">{{ data.refundDispute.mediateResult === '3' ? '退费' : data.refundDispute.mediateResult === '4' ? '不退费' : '' }}</p>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>

    </div>
  </div>
</template>

<script>
import {cancelClasses, confirmClasses, getUnpaidDetailById} from "../../api/course/course";
import {FILE_DISPLAY_PREFIX} from "../../api/upload";
import {getDictByType} from "../../api/common";

export default {
  name: "unpaid",
  data() {
    return {
      statusList: [],
      loading: false,
      activeNames: ['1', '2','3'],
      data: {},
      fileDisplayPrefix: FILE_DISPLAY_PREFIX

    }
  },
  created() {
 window.scrollTo(0,0)

    getDictByType("return_status").then(res => {
      if (res.code === 10000) {
        this.statusList = res.result.map(item => {
          return {label: item.dictKey, value: item.dictValue}
        })
      }
    })
    this.data.id = this.$route.query.id

    this.getData(this.$route.query.id)

  },
  methods: {
    getData(id) {
      getUnpaidDetailById(id).then(res => {
        if (res.code === 10000) {
          this.data = res.result
        }
      })
    },


    confirm(res) {
      this.loading = true
      const data = {
        id: res.id,
        time: 1
      }
      confirmClasses(data).then(res => {
        if (res.code === 10000) {
          this.loading = false
          this.getData(this.data.id)
          this.$toast("确认成功！")

        }
      })
    },

    cancel(res) {
      this.loading = true
      const numerics = {
        id: res.id,
        status: '2'
      }
      cancelClasses(numerics).then(res => {
        if (res.code === 10000) {
          this.loading = false
          this.getData(this.data.id)
          this.$toast("操作成功！")

        }
      })
    },

    onClickLeft() {
      this.$router.push({path: `/course`})
    },

    onDispute() {
      this.$router.push({path: `/disputeList/Add`})
    },
    getDisputeUrl(returnId) {
      this.$router.push({path: `/disputeList/Add?returnId=${returnId}`})
    },
    getReturnPremium(res) {
      this.$router.push({path: `/course/returnPremium?id=${res.id}`})
    }

  }
}
</script>

<style scoped>
.yhf {
  width: 75px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #66C779;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  color: #66C779;
}

.dhf {
  width: 75px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #ff9900;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  color: #ff9900;
}

.zyz {
  width: 75px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #ff6600;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  color: #ff6600;
}

.yjj {
  width: 75px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #ff0000;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  color: #ff0000;
}

.yqr {
  width: 75px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #A7A7A7;
  color: #a7a7a7;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

.button-box {
  display: flex;
  align-items: center;
  padding-top: 15px;
}

.xk-but {
  display: flex;
  padding: 0 20px;
  background: url("~@/assets/button-style.png") 3px 3px no-repeat #66C779;
  background-size: 11px 15px;
  border-radius: 25px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
  margin-right: 10px;
}

.org {
  background: url("~@/assets/button-style.png") 3px 3px no-repeat #FF6600;
  background-size: 11px 15px;
}

.blue {
  background: url("~@/assets/button-style.png") 3px 3px no-repeat #8B7FFF;
  background-size: 11px 15px;
}

.xk-box-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.xk-box-top b {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}

/deep/ .xk-box {
  margin-bottom: 10px;
}

/deep/ .van-collapse-item__content {
  padding: 12px 0;
}

/deep/ .van-cell {
  padding: 10px 0;
}

/deep/ .van-cell::after {
  left: 0;
  right: 0;
}

.yj-box {
  display: flex;
  margin: 0 10px;
  flex-direction: column;
}

.box-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 16px;
  margin-top: 23px;
  margin-bottom: 17px;
}

.box-title h2 {
  display: flex;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}

.box-title img {
  width: 16px;
  height: 9px;
}

.yj-con {
  background: #F4F5F7;
  border-radius: 12px;
  display: flex;
  padding: 17px;
  flex-direction: column;
}

.yj-con h1 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 20px;
}

.con-list {
  display: flex;
  margin-bottom: 15px;
  align-items: center;
}

.con-list:last-child {
  margin-bottom: 0;
}

.con-list span {
  display: flex;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  width: 75px;
  justify-content: flex-end;
  padding-right: 5px;
}

.con-list p {
  display: flex;
  flex: 1;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  flex-wrap: wrap;
}

.con-list p img {
  height: 15vw;
  width: 73px;
  margin-right: 5px;
  margin-bottom: 5px;
  border-radius: 3px;
}

.con-list p em {
  display: flex;
  height: 28px;
  background: #FFFFFF;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding: 8px 10px;
  margin-right: 5px;
}

/deep/ .van-uploader__preview-image {
  height: 15vw;
  width: 73px;
}

.box-style {
  padding-bottom: 20px;
}
</style>
